import { defineStore } from 'pinia'
import { SearchItem } from '@/types/KaisyaRenraku'
import OptionConst from '@/const/Option'

export const useRenrakuStore = defineStore('Renraku', {
  state: () => {
    return {
      item:<SearchItem> {
        keyword: null,
        readType: OptionConst.RENRAKU_SERACH_READ.ALL,
        dataType: OptionConst.RENRAKU_SERACH_TYPE.RECEIVE,
        buka: null,
        date: null,
        userId: null
      },
    }
  },
  actions: {
    // 検索条件のセット
    setItem(searchItem: SearchItem) {
      this.item = searchItem
    },
    // 検索条件のクリア
    removeItem() {
      this.item = {
        keyword: null,
        readType: OptionConst.RENRAKU_SERACH_READ.ALL,
        dataType: this.item.dataType,
        buka: null,
        date: null,
        userId: null
      };
    },
    // 別ページ遷移時の検索条件
    removePage() {
      this.item = {
        keyword: null,
        readType: OptionConst.RENRAKU_SERACH_READ.ALL,
        dataType: OptionConst.RENRAKU_SERACH_TYPE.RECEIVE,
        buka: null,
        date: null,
        userId: null
      };
    }
  },
  getters: {
    searchItem(): SearchItem {
      return this.item
    },
  }
})